module.exports = __webpack_public_path__ + "static/sovereign_glue-9a28d767ed5ac1c5c85cdfac90a6a24c.jpeg";